import { createFileRoute } from '@tanstack/react-router';
import { JourneysCustomerioHandoff } from '@/pages/workspaces/journeys/integrations/customerio/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/customerio` URL — what the Ember directory and the
 * activity-log empty state link to. Flag off it renders the embedded Ember host; flag on it
 * forwards to the migrated URL.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the `journeys` segment, so
 * the resolver's bundle-aware branch can rebuild the target from the bundle prefix when the
 * `/workspaces/last` sentinel needs resolving.
 */
function JourneysCustomerioConnectorRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysCustomerioHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio')({
  component: JourneysCustomerioConnectorRoute,
});
